// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-helper-ShIpAv {
  display: -ms-flexbox;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-1-helper-Q7chB6 {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  flex: 1;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-direction-row-helper-osci3z {
  flex-direction: row;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-items-center-ILL8QQ {
  -ms-flex-align: center;
  align-items: center;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-justify-center-N94WvM {
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-wrapper-IYyBDT {
  background: #e5b65c;
  width: 100%;
  min-height: 48px;
  padding: 0 64px;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-item-ythuzb {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-upgrade-button-VjMApZ {
  cursor: pointer;
  text-underline-offset: 4px;
  margin-left: 6px;
  font-weight: bold;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}

.\\------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__close-t8y_kt {
  cursor: pointer;
  color: #fff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex-helper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-helper-ShIpAv`,
	"flexHelper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-helper-ShIpAv`,
	"flex-1-helper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-1-helper-Q7chB6`,
	"flex1Helper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-1-helper-Q7chB6`,
	"flex-direction-row-helper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-direction-row-helper-osci3z`,
	"flexDirectionRowHelper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-direction-row-helper-osci3z`,
	"flex-items-center": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-items-center-ILL8QQ`,
	"flexItemsCenter": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-items-center-ILL8QQ`,
	"flex-justify-center": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-justify-center-N94WvM`,
	"flexJustifyCenter": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__flex-justify-center-N94WvM`,
	"banner-wrapper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-wrapper-IYyBDT`,
	"bannerWrapper": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-wrapper-IYyBDT`,
	"banner-item": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-item-ythuzb`,
	"bannerItem": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-item-ythuzb`,
	"banner-upgrade-button": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-upgrade-button-VjMApZ`,
	"bannerUpgradeButton": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__banner-upgrade-button-VjMApZ`,
	"close": `------packages-foundation-browser-upgrade-banner-src-components-browser-upgrade-wrap-index-module__close-t8y_kt`
};
export default ___CSS_LOADER_EXPORT___;
